export default __webpack_public_path__ + "static/media/Banner-Curso-Word-Intermedio.69b6014c.jpg";